import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { LayoutService } from '../../../@core/data/layout.service';
import { generalSettings } from '../../../../main/settings';
import { GeneralService } from '../../../@core/data/general.service';

@Component({
  selector: 'edm-waiting',
  templateUrl: './dialog.waiting.component.html',
  styleUrls: ['./dialog.waiting.component.scss'],
  standalone: false
})

export class WaitingDialogComponent {

  @Input() waitingTitle: string = this.getTranslate("title");
  @Input() waitingSubtitle: string = this.getTranslate("subtitle");
  pathBaseTranslate: string = 'timeline.lessons.dialog-waiting.';

  constructor(
    private activeModal: NgbActiveModal,
    private generalService: GeneralService,
    private layoutService: LayoutService
  ) { }

  getTranslate(key: string): string {
    return this.generalService.getTranslate(`${this.pathBaseTranslate}${key}`);
  }

  buttonCustomLayoutCss(): string {
    return this.layoutService.buttonCustomLayoutCss();
  }

  iconCustomLayoutClass(): string {
    return generalSettings.timelineIconsLayout + '-icon';
  }

  iconTypeLayoutClass(): string {
    return generalSettings.iconsType + '-icons-type';
  }

  closeModal(submit: boolean = false): void {
    submit ? this.activeModal.close() : this.activeModal.dismiss();
  }
}
